import { api } from './api'

export const fetchBookingPayment = (query) => api.get('/booking-payment', query)
